<div class="fxLayout">
  <section id="calendar" fxFlex>
    <div class="flex justify-center items-center w-full pt-4" *ngIf="loading; else calendar">
      <mat-spinner [diameter]="32"></mat-spinner>
    </div>
    <ng-template #calendar>
      <ng-container *ngIf="data?.data?.length">
        <sbnb-multi-calendar [data]="data"></sbnb-multi-calendar>
      </ng-container>
    </ng-template>
  </section>
</div>
